import React from 'react';
import { PlaybookEntry, ServiceDetail, ServiceVersion } from '../servicesShared';
import PlaybookTab from './PlaybookTab';
import VersionsTab from './VersionsTab';

/**
 * Improvement: how the service gets better. The playbook (answers your team
 * gave that now steer every job) and the published versions to restore from.
 */
export const ImprovementTab: React.FC<{
    service: ServiceDetail;
    playbook: PlaybookEntry[];
    hasDraft: boolean;
    onRestore: (version: ServiceVersion) => Promise<void>;
}> = ({ service, playbook, hasDraft, onRestore }) => (
    <>
        <PlaybookTab entries={playbook} />
        <VersionsTab serviceId={service.id} currentVersionId={service.current_published_version_id} hasDraft={hasDraft} onRestore={onRestore} />
    </>
);

export default ImprovementTab;
